const KeenSlider = window.KeenSlider

const { setInitialised } = window.BAO.Carousel.plugins

class StyleWith extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (!window.BAO.MediaBreakpoints.isMd) {
      this.carousel = this.setupCarousel()
    }
  }

  setupListeners () {
    this.handleMouseEnter = this.handleMouseEnter.bind(this)
    this.handleMouseLeave = this.handleMouseLeave.bind(this)

    if (window.BAO.MediaBreakpoints.isMd) {
      this.els.item?.elements.forEach((item) => {
        this.listeners.add(item, 'mouseenter', this.handleMouseEnter)
        this.listeners.add(item, 'mouseleave', this.handleMouseLeave)
      })
    }
  }

  handleMouseEnter (e) {
    const target = e.target.closest('[data-style-with-el="item"]')

    this.els.title.element.innerHTML = `<span class="prd-StyleWith_Name">${target.dataset.title}</span><span class="prd-StyleWith_Price">${target.dataset.price}</span>`
  }

  handleMouseLeave () {
    this.els.title.element.innerHTML = `${window.theme.strings.productStrings.styleWith}`
  }

  setupCarousel () {
    if (!this.els.slide?.exists) return

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1.3,
          spacing: 24,
          origin: 'center',
        },
        breakpoints: {
          '(min-width: 1023px)': {
            disabled: true,
          },
        },
      },
      [setInitialised()],
    )
  }
}

if (!customElements.get('style-with')) {
  customElements.define('style-with', StyleWith)
}
